import division from './division'
let letter = new Array(62).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

export default function changeSunType(equation) {
  let {num1, num2} = equation
  console.log(JSON.parse(JSON.stringify(equation)))
  if((!num1 && num1 != 0) || (!num2 && num2 != 0)) return;

  // switch(sumType) {
  //   case '+' : num3 = Number(num1) + Number(num2) ;break
  //   case '-' : num3 = num1 - num2 ;break
  //   case '*' : num3 = num1 * num2 ;break
  //   case '/' : num3 = Math.floor(num1 / num2) ;break
  // }
  // equation.num3 = num3
  return save(equation)
}

function save(equation) {
  // 算出所有值
  let {num1, num2, num3, num4, sumType} = equation, numList,
  arr = [[], [], []]

  if(num3 != undefined) {
    arr.push([])
  }

  if(sumType == '/') numList = handleDivision(division(equation))
  else {
    num1 = String(num1)
    num2 = String(num2)
    num4 = String(num4)

    let leng = Math.max((num1).length, (num2).length, (num4).length)
    if(num3 != undefined) {
      num3 = String(num3)
      leng = Math.max(leng, (num3).length)
    }
    while(leng > 0) {
      arr[0].unshift(num1[num1.length - 1] || '#')
      arr[1].unshift(num2[num2.length - 1] || '#')
      arr[arr.length - 1].unshift(num4[num4.length - 1] || '#')
      if(num3 != undefined) {
        arr[2].unshift(num3[num3.length - 1] || '#')
        num3 = num3.substr(0, num3.length - 1)
      }

      num1 = num1.substr(0, num1.length - 1)
      num2 = num2.substr(0, num2.length - 1)
      num4 = num4.substr(0, num4.length - 1)

      leng --
    }
    console.log(arr)
    numList = handleSum(arr)
  }

  console.log(numList)
  return numList
}

/**
 * 加减乘
 * @param {*} arr
 * [
 *   ['2', '3', '4', '1', '2'],
 *   ['#', '2', '3', '4', '1'],
 *   ['2', '5', '7', '5', '3'], 
 * ]
 */
function handleSum(arr) {
  let newArr = []
  newArr = arr.map(its => 
    its.map(item => 
      ({num: item, check: letter.includes(item)})
    )
  )

  return newArr
}
/**
 * 除
 * @param {*} dataObj
 * {
 *    divisor: ['2'],
 *    list: [
 *      ['#', '6', '2'],
 *      ['1', '2', '4'],
 *      ['1', '2', '#'],
 *      ['#', '#', '4'],
 *      ['#', '#', '4'],
 *      ['#', '#', '0'],
 *    ]
 * }
 */
 function handleDivision(dataObj) {
  let divisor = [], list = [];

  // {num: '2', check: false}
  divisor = dataObj.divisor.map(its => ({num: its, check: letter.includes(its)}))
  list = dataObj.list.map(its => 
    its.map(item => 
      ({num: item, check: letter.includes(item)})
    )
  )

  return {divisor, list}
}